export const getEnvVariables = () => {
    const {
        VITE_PUBLIC_AUTH_URL,
        VITE_PUBLIC_HASURA_URL,
        VITE_PUBLIC_USE_PLACELEFT,
        MODE,
    } = import.meta.env;
    return {
        VITE_PUBLIC_USE_PLACELEFT: VITE_PUBLIC_USE_PLACELEFT && JSON.parse(VITE_PUBLIC_USE_PLACELEFT),
        VITE_PUBLIC_AUTH_URL,
        VITE_PUBLIC_HASURA_URL,
        MODE,
    };
};
